import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) =>
  Cookies.set(sidebarStatusKey, sidebarStatus, {
    sameSite: 'Strict',
    secure: true,
  })

// TOKEN CREDENTIAL
const tokenKey = `${process.env.NODE_ENV}_admin_access_token`
const expiredTokenKey = `${process.env.NODE_ENV}_admin_expired_token`
const userRolePermission = `${process.env.NODE_ENV}_user_role_permission`
const salesCode = `${process.env.NODE_ENV}_sales_code`

export const getToken = () => Cookies.get(tokenKey) || ''
export const getExpired = () => Cookies.get(expiredTokenKey)
export const setCredential = ({ token, expired }) => {
  Cookies.set(tokenKey, token, {
    sameSite: 'Strict',
    secure: true,
  })
  Cookies.set(expiredTokenKey, expired, {
    sameSite: 'Strict',
    secure: true,
  })
}
export const removeAuthCredential = () => {
  Cookies.remove(tokenKey)
  Cookies.remove(expiredTokenKey)
  localStorage.removeItem(userRolePermission)
  localStorage.removeItem(salesCode)
}

export const setUserRolePermission = (data: any) => {
  localStorage.setItem(userRolePermission, JSON.stringify(data))
}

export const getUserRolePermission = () =>
  localStorage.getItem(userRolePermission) || '[]'

export const setSalesCode = (data: any) => {
  localStorage.setItem(salesCode, JSON.stringify(data))
}

export const getSalesCode = () => localStorage.getItem(salesCode) || ''
